import React, { useContext } from "react";
import { ExtraContext } from "./ExtraFunctions";
import { CartServerSide } from "./api_response";

export const CartContext = React.createContext();

const CartProvider = (props) => {
  const { cart, setCart } = useContext(CartServerSide);
  const {
    amount,
    crust,
    size,
    handleIncrease,
    handleDecrease,
    get_crust,
    get_size,
    get_delivery,
    delivery,
    edit,
    setEdit,
    setCrust,
    setSize,
    setAmount,
  } = React.useContext(ExtraContext);

  const add_to_cart = (dish) => {
    let get_size = size === "" ? "small" : size;
    let get_crust = crust === "" ? "Original crust" : crust;
    let newCart;
    let {
      Title,
      Description,
      price_large,
      price_small,
      price_medium,
      id,
      toppings,
      ingridients,
      image,
    } = dish;
    let newItem = {
      Title,
      Description,
      price_large,
      price_small,
      price_medium,
      id,
      amount,
      toppings,
      ingridients,
      image,
      get_size,
      get_crust,
    };
    if (edit) {
      newCart = [...cart].map((item) => {
        return item.id === id
          ? { ...item, get_size, amount, get_crust }
          : { ...item };
      });
      setEdit(false);
      setCart(newCart);
      setCrust("");
      setSize("");
      setAmount(1);
      return newCart;
    }

    let findItem = cart.find((item) => item.id === id);
    if (findItem) {
      newCart = increase_item(findItem.id);
      setCart(newCart);
      return newCart;
    } else {
      newCart = [...cart, newItem];
      setCart(newCart);
      setCrust("");
      setSize("");
      setAmount(1);
      return newCart;
    }
  };

  const increase_item = (id) => {
    let increment = [...cart].map((item) => {
      return item.id === id
        ? { ...item, amount: item.amount + 1 }
        : { ...item };
    });
    setCart(increment);
    return increment;
  };

  const remove_item = (id) => {
    let remove = [...cart].filter((item) => item.id !== id);
    setCart(remove);
    return remove;
  };

  const decrease_item = (id, amount) => {
    let decr;
    if (amount === 1) {
      decr = remove_item(id);
      setCart(decr);
      return decr;
    } else {
      let increment = [...cart].map((item) => {
        return item.id === id
          ? { ...item, amount: item.amount - 1 }
          : { ...item };
      });
      setCart(increment);
      return increment;
    }
  };

  const empty_cart = () => {
    let newCart = [];
    setCart(newCart);
    return newCart;
  };

  return (
    <CartContext.Provider
      value={{
        get_crust,
        get_size,
        size,
        amount,
        crust,
        delivery,
        add_to_cart,
        handleIncrease,
        handleDecrease,
        increase_item,
        decrease_item,
        remove_item,
        empty_cart,
        get_delivery,
      }}
    >
      {props.children}
    </CartContext.Provider>
  );
};

export { CartProvider as default };
